import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useTable } from 'react-table'
import { withAuthHeader } from '../../routes/authRequest';
import routes from '../../routes/routes';

const ReactTableComponent = ({ data: tableData, header }) => {
    // console.log(tableData, header);
    const [events, setEvents] = useState('')

    useEffect(() => {
        withAuthHeader.get(routes.api.locations.getEvent)
            .then(res => {
                setEvents(res.data[0].data)
                console.log(res.data[0].data);
            })
            .catch(err => {
                console.log(err);
            })
    }, [])
    const data = React.useMemo(
        () => events || [],
        [events]
    )

    const columns = React.useMemo(
        () => [
            {
                Header: 'title',
                accessor: 'title', // accessor is the "key" in the data
            },
            {
                Header: 'Category',
                accessor: 'category',
            },
            {
                Header: 'description',
                accessor: 'description',
            },
            {
                Header: 'address',
                accessor: 'address',
            },
            {
                Header: 'start_date',
                accessor: 'start_date',
            },
            {
                Header: 'end_date',
                accessor: 'end_date',
            },
        ],
        []
    )
    const tableInstance = useTable({ columns, data })

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = tableInstance

    const deleteEvent = (id) => {
        // console.log(id);
        withAuthHeader.post(routes.api.locations.deleteEvent, { id })
            .then(res => {
                setEvents(events.filter((event) => event.id !== id))
                console.log(res.data);
            })
            .catch(err => {
                console.log(err);
            })
    }
    return (
        // apply the table props
        <table {...getTableProps()} className="table table-hover table-responsive">
            <thead className="thead-dark">
                {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map(column => (
                            <th
                                {...column.getHeaderProps()}
                            >
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                    prepareRow(row)
                    return (
                        <tr {...row.getRowProps()}>
                            {row.cells.map(cell => {
                                return (
                                    <td
                                        {...cell.getCellProps()}
                                    >
                                        {cell.render('Cell')}
                                    </td>
                                )
                            })}
                            <td>
                                <Link to={
                                    {
                                        pathname: routes.public.editEvent,
                                        state: { event: row.original }
                                    }}
                                    class="btn btn-default"
                                >
                                    Edit
                                </Link>
                            </td>
                            <td>
                                <button
                                    class="btn btn-danger"
                                    onClick={(event) => deleteEvent(row.original.id)}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    )
                })}
            </tbody>
        </table>
    )
}

export default ReactTableComponent
